module.exports = __webpack_public_path__ + "img/backgroundimg.f2aeefbd.svg";